import config from "constants/config";
import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import tradevuTransferReducer from "../redux/slices/tradevuTransferSlice";
import bankTransferReducer from "../redux/slices/bankTransferSlice";
import cryptoTransferReducer from "../redux/slices/cryptoTransferSlice";
import cryptoFiatTransferReducer from "../redux/slices/cryptoFiatTransferSlice";
import usdTransferReducer from "../redux/slices/usdTransferSlice";
import crossBorderTransferReducer from "../redux/slices/crossBorderTransferSlice";

const loginStoreName = config.LOGIN_STORE_NAME;

const initialState = {
    users: [],
    token: "",
    isLogin: !!localStorage.getItem(loginStoreName),
    businessid: "",
    business: [],
  businessList: [],
    businessSwitching: false,
    isLoading: true,
    email: "",
    wallets: [],
  kycStatus: "",
    currency: localStorage.getItem("default") ?? "NGN",

    amount: "",
    memo: "",
    invoice: null,
    otherDocument: null,
    recipient: {
        name: "",
        accountNumber: "",
        bankName: "",
        userId: "",
    },
    provider: null,

    bankRecipient: {
        name: "",
        accountNumber: "",
        bankName: "",
        bankCode: "",
        swiftCode: "",
    },
    bankProvider: null,
    recipientAmount: "",
    recipientCurrency: "",
    recipientMemo: "",
    recipientInvoice: null,
    recipientOtherDocument: null,

    cryptoTransfer: {
        token: "USDC",
        network: "ERC20",
        address: "",
        amount: "",
        naration: "",
        invoice: null,
        supportDocument: null,
    },
    cryptoFiatTransfer: {
        currency: "USDC",
        amount: "",
        pin: "",
        recipient: {
            institution: "",
            accountIdentifier: "",
            accountName: "",
            memo: "",
            bankName: "",
            toCurrency: "NGN",
        },
    },
    usdTransfer: undefined,
    crossBorderTransfer: undefined,
};

const AuthReducer = (state = initialState, action) => {
    const tradevuState = tradevuTransferReducer(
        {
            amount: state.amount || "",
            memo: state.memo || "",
            invoice: state.invoice || null,
            otherDocument: state.otherDocument || null,
            recipient: state.recipient || {
                name: "",
                accountNumber: "",
                bankName: "",
                userId: "",
            },
            provider: state.provider || null,
        },
        action
    );
    const { currency: tradevuCurrency, ...tradevuTransferState } = tradevuState;
    const nextCurrency =
        action.type === "tradevuTransfer/setCurrency" ? tradevuCurrency : state.currency;

    const bankTransferState = bankTransferReducer(
        {
            recipientAmount: state.recipientAmount || "",
            recipientCurrency: state.recipientCurrency || "",
            recipientMemo: state.recipientMemo || "",
            recipientInvoice: state.recipientInvoice || null,
            recipientOtherDocument: state.recipientOtherDocument || null,
            bankRecipient: state.bankRecipient || {
                name: "",
                accountNumber: "",
                bankName: "",
                bankCode: "",
                swiftCode: "",
            },
            bankProvider: state.bankProvider || null,
        },
        action
    );

    const cryptoTransferState = cryptoTransferReducer(
        state.cryptoTransfer || initialState.cryptoTransfer,
        action
    );

    const cryptoFiatTransferState = cryptoFiatTransferReducer(
        state.cryptoFiatTransfer || initialState.cryptoFiatTransfer,
        action
    );

    const usdTransferState = usdTransferReducer(state.usdTransfer || undefined, action);
    if (action.type === "LOGIN") {
        localStorage.setItem(loginStoreName, true);
        return {
            ...state,
            users: action.payload?.user || {},
            token: action.payload?.token || "",
            isLogin: true,
            isLoading: false,
            business: [],
            businessid: "",
            businessList: [],
            wallets: [],
            ...tradevuTransferState,

            // dispatch('attempt',action)
        };
    }

    const crossBorderState = crossBorderTransferReducer(
        state.crossBorderTransfer || undefined,
        action
    );

    if (action.type === "USER_PROFILE") {
        localStorage.setItem(loginStoreName, true);
        return {
            ...state,
            users: action.payload.data.data,
            isLogin: true,
            isLoading: false,
        };
    }
    if (action.type === "BUSINESS_RES") {
        return {
            ...state,
            businessid: action.payload.data._id,
            business: action.payload.data,
        };
    }
    if (action.type === "BUSINESS_SWITCH_START") {
        return {
            ...state,
            businessSwitching: true,
        };
    }
    if (action.type === "BUSINESS_SWITCH_COMPLETE") {
        return {
            ...state,
            businessid: action.payload.business._id,
            business: action.payload.business,
            currency: action.payload.currency,
            wallets: action.payload.wallets,
            businessSwitching: false,
        };
    }
    if (action.type === "BUSINESS_SWITCH_CANCEL") {
        return {
            ...state,
            businessSwitching: false,
        };
    }
    if (action.type === "BUSINESSES_RES") {
        return {
            ...state,
            wallet: action?.payload?.data?.allWallets,
        };
    }
  if (action.type === "BUSINESSES_LIST_RES") {
    return {
      ...state,
      businessList: action?.payload,
    };
  }
    if (action.type === "LOGOUT") {
        localStorage.removeItem(loginStoreName);
        return {
            ...state,
            wallet: [],
            users: [],
            business: [],
            businessid: "",
            isLogin: false,
            businessList: [],
            wallets: [],
            token: "",
        };
    }
    if (action.type === "CLOSE_ACCOUNT") {
        localStorage.removeItem(loginStoreName);
        return {
            ...state,
            wallet: [],
            users: [],
            business: [],
            businessid: "",
            isLogin: false,
            businessList: [],
            wallets: [],
            token: "",
        };
    }

  if (action.type === "KYC_STATUS") {
    return {
      ...state,
      kycStatus: action.payload,
    };
  }

    if (action.type === "WALLETS") {
        return {
            ...state,
            wallets: action.payload,
        };
    }

    if (action.type === "CURRENCY") {
        return {
            ...state,
            currency: action.payload,
        };
    }

    if (action.type === "BUSINESS") {
        return {
            ...state,
            business: action.payload,
        };
    }

    return {
        ...state,
        ...tradevuTransferState,
        currency: nextCurrency,
        ...bankTransferState,
        cryptoTransfer: cryptoTransferState,
        cryptoFiatTransfer: cryptoFiatTransferState,
        usdTransfer: usdTransferState,
        crossBorderTransfer: crossBorderState,
    };
};

const store = createStore(AuthReducer, composeWithDevTools());

export default store;
